import { combineReducers } from 'redux'
import app from 'services/app-state'
import ui from 'services/ui-state'
import sng from '../scenes/scan-and-go/services/app-state'

const rootReducer = combineReducers({
  app,
  ui,
  sng,
})

export default rootReducer
